export class HttpAzureFunctions {
    static ImportHttpTasks = 'ImportTimeChimpDataTasks';
    static ImportHttpTags = 'ImportTimeChimpDataTags';
    static ImportHttpTimes = 'ImportTimeChimpDataTimes';
    static SyncWorkorders = 'SyncWorkorders';
    static SyncCustomers = 'SyncCustomers';
}
